var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"buttonEditItem d-flex items-center px-3 py-1 text-14"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }